import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const gamerBundle: 'a' | 'b' | undefined = getFeature('gamer-bundle');

export const gamerBundleEnabled = gamerBundle === 'b';
